// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function make(param) {
  return {
          identifierByDomElement: {
            contents: CustomMap$SmartcutsMacros.MapDomElement.make(undefined)
          },
          nextDomElementIdentifier: {
            contents: 0
          }
        };
}

function t_encode(_generator) {
  return "domElementIdentifierGenerator";
}

function t_decode(encoded) {
  var str = Js_json.decodeString(encoded);
  if (str !== undefined) {
    if (str === "domElementIdentifierGenerator") {
      return {
              TAG: /* Ok */0,
              _0: make(undefined)
            };
    } else {
      return Decco.error(undefined, "Expected 'domElementIdentifierGenerator' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
    }
  } else {
    return Decco.error(undefined, "Couldn't decode json into DomElementIdentifierGenerator.t", encoded);
  }
}

function stringify(param) {
  return "{identifierByDomElement=" + (StringUtils$SmartcutsMacros.join(", ", List.map((function (param) {
                      return "[element]=" + String(param[1]);
                    }), Belt_Map.toList(param.identifierByDomElement.contents))) + (", nextDomElementIdentifier=" + (String(param.nextDomElementIdentifier.contents) + "}")));
}

function identifierForElement(element, generator) {
  var identifierByDomElement = generator.identifierByDomElement.contents;
  var domElementIdentifier = Belt_Map.get(identifierByDomElement, element);
  if (domElementIdentifier !== undefined) {
    return domElementIdentifier;
  }
  var nextDomElementIdentifier = generator.nextDomElementIdentifier.contents;
  generator.identifierByDomElement.contents = Belt_Map.set(identifierByDomElement, element, nextDomElementIdentifier);
  generator.nextDomElementIdentifier.contents = nextDomElementIdentifier + 1 | 0;
  return nextDomElementIdentifier;
}

function identifierForNode(node, domElementIdentifierGenerator) {
  var element = Webapi__Dom__Element.ofNode(node);
  if (element !== undefined) {
    return identifierForElement(Caml_option.valFromOption(element), domElementIdentifierGenerator);
  }
  
}

exports.make = make;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.identifierForElement = identifierForElement;
exports.identifierForNode = identifierForNode;
/* Webapi__Dom__Element Not a pure module */
